// src/api/riskApi.js
import axios from "axios";

const BASE_URL = "https://ims.holdthechild.net/api";

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

/**
 * Fetch all risks from the backend
 */
export const getRisks = async () => {
  try {
    const res = await axios.get(`${BASE_URL}/risks`, {
      headers: getAuthHeaders(),
    });
    return res.data; // array of risk objects
  } catch (error) {
    console.error("Error fetching risks:", error);
    throw error;
  }
};

/**
 * Create a new risk
 * @param {Object} riskData - data from RiskFormModal
 */
export const createRisk = async (riskData) => {
  try {
    const res = await axios.post(`${BASE_URL}/risks`, riskData, {
      headers: getAuthHeaders(),
    });
    return res.data; // newly created risk
  } catch (error) {
    console.error("Error creating risk:", error);
    throw error;
  }
};

/**
 * Delete a risk by ID
 * @param {string} riskId
 */
export const deleteRisk = async (riskId) => {
  try {
    const res = await axios.delete(`${BASE_URL}/risks/${riskId}`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (error) {
    console.error("Error deleting risk:", error);
    throw error;
  }
};

/**
 * Update a risk by ID
 * @param {string} riskId
 * @param {Object} updatedData
 */
export const updateRisk = async (riskId, updatedData) => {
  try {
    const res = await axios.put(`${BASE_URL}/risks/${riskId}`, updatedData, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (error) {
    console.error("Error updating risk:", error);
    return { data: [] }; 
  }
};
export const bulkUploadRisks = async (risksData) => {
  try {
    const res = await axios.post(`${BASE_URL}/risks/bulk`, risksData, {
      headers: getAuthHeaders(),
    });
    return res.data; // response from server
  } catch (error) {
    console.error("Error bulk uploading risks:", error);
    throw error;
  }
};

/**
 * Get a signed URL for uploading a file
 */
export const getRiskUploadUrl = async ({ filename, filetype, riskId, category }) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/documents/upload-url`,
      { filename, filetype, entityId: riskId, entityType: "risk", category },
      { headers: getAuthHeaders() }
    );
    return res.data; // { uploadUrl, fileUrl, key }
  } catch (error) {
    console.error("Error getting risk upload URL:", error);
    throw error;
  }
};

/**
 * Save uploaded risk document metadata
 */
export const saveRiskDocument = async ({ fileUrl, category, originalName, fileType, riskId, key }) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/documents`,
      { fileUrl, category, originalName, fileType, entityId: riskId, entityType: "risk", key },
      { headers: getAuthHeaders() }
    );
    return res.data; // saved document object
  } catch (error) {
    console.error("Error saving risk document metadata:", error);
    throw error;
  }
};

